export const environment = {
  dev: true,
  cookieDomain: 'scattre.co',

  domain: 'scattre.co',
  origin: 'http://test-canvas.scattre.co',
  cdn: 'https://e02c89b7-148a.scattre.co:4000',
  scattre: {
    main: 'http://192.168.0.21:4202',
    auth: 'http://192.168.0.21:4201',
    threed: 'https://e02c89b7-148a.scattre.co:4000',
    account: 'https://e02c89b7-148a.scattre.co:3000',
    ai: 'https://api.stability.ai/v1/generation/stable-diffusion-xl-1024-v1-0/text-to-image',
  },
  saleor: {
    server: 'https://e02c89b7-148a.scattre.co:3000',
    dashboard: 'http://192.168.0.21:9001/',
    storeFront: 'http://192.168.0.21:4200',
  },
  google: {
    clientId: '4197249581-i2ec7rftjdkvln394r95t7g9o541v44r.apps.googleusercontent.com',
    clientSecret: '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',
  },
  demoEmbedData1: {
    uuid: '3e557734-031a-410d-8c0a-93405a0633d6',
    title: 'Scattre',
    description: 'scattre embed system.',
    thumbnail: 'https://threed-server.s3.ap-northeast-2.amazonaws.com/media/logo/karbel+(1).png',
    projects: ['bd163aca-a298-48bc-8802-1b2d7082ccbd'],
    isCapture: false,
    isFullScreen: false,
    isAutoRotation: false,
  },

  demoEmbedData2: {
    uuid: '3e557734-031a-410d-8c0a-93405a0633d6',

    title: 'Scattre',
    description: 'scattre embed system.',
    thumbnail: 'https://threed-server.s3.ap-northeast-2.amazonaws.com/media/logo/takd.png',
    projects: ['bd163aca-a298-48bc-8802-1b2d7082ccbd'],
    isCapture: false,
    isFullScreen: false,
    isAutoRotation: false,
  },
};
